<template>
    <div class="supporter-sub">
        <a :href="ad.url" target="_blank" :class="ad.url === null? 'no-mouse':''">
            <img :src="ad.image_url"
                 alt="Supporter Logo"
                 class="supporter-sub d-flex justify-content-center align-items-center">
        </a>
    </div>

</template>

<script>
    export default {
        name: "AdTemplate",
        props: {
            ad: {
                type: Object,
                required: true
            },
        },
    }
</script>

<style lang="scss" scoped>
    .supporter-sub {
        border-radius: 6px;
        overflow: hidden;

    }
    .supporter-sub-image{
        /*width: 312px;*/
        /*height: 156px;*/
        background-size: cover;
    }
    .no-mouse {
        pointer-events: none;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/shared/AdTemplate.vue